import type {TStore} from "modules/types/store";

export const getPromPTModalState = (store: TStore) => store.promptStore.modal;
